import { useTranslation } from 'react-i18next';
import type { PageType } from 'types';
import type { PopularProductsModule } from 'types/capi/modules';

import CarouselScroller from '~/components/CarouselScroller';
import ProductCard from '~/components/ProductCard';
import Tracked from '~/components/Tracked';

type Props = { items: PopularProductsModule['items']; pageType: PageType };

function ProductsCarousel({ items, pageType }: Props) {
  return (
    <CarouselScroller slidesClassName="gap-2 md:gap-6">
      {items.map((product, productIndex) => {
        const baseProps = {
          allowNotifications: true,
          cardSize: 'small' as const,
          className: 'w-[42vw] flex-none md:w-[264px]',
          imageLoading: 'eager' as const,
          overrideInteractionPagePosition: true,
          padImage: true,
          pagePosition: 'Homepage Whats Hot' as const,
          position: productIndex + 1,
          showNotificationCount: true
        };

        return product.type === 'external' ? (
          <ProductCard.External
            key={`product-${productIndex}`}
            product={product}
            pageType={pageType}
            {...baseProps}
          />
        ) : (
          <ProductCard.Internal
            key={`product-${productIndex}`}
            product={product}
            pageType={pageType}
            {...baseProps}
          />
        );
      })}
    </CarouselScroller>
  );
}

function ViewMoreButton() {
  const { t } = useTranslation('common');

  return (
    <div className="w-36">
      <Tracked.InternalLink
        variant="transparent-black-border"
        className="flex items-center justify-center"
        pagePosition="Homepage Whats Hot"
        name="VIEW_MORE"
        to="/release-dates/"
      >
        {t('viewMore')}
      </Tracked.InternalLink>
    </div>
  );
}

export default function PopularProducts({ items, pageType }: Props) {
  const { t } = useTranslation('home');

  return (
    <div className="w-full">
      <div className="flex flex-col items-center justify-center gap-6 px-0 py-10 max-md:px-4 md:mx-auto md:max-w-desktop md:gap-8 md:py-20">
        <div className="flex flex-col gap-6 self-stretch py-0 md:gap-10">
          <div className="flex flex-col gap-2">
            <h2 className="text-title-xl flex flex-col justify-start gap-2 text-left">
              {t('whatsHot')}
            </h2>
            <div className="text-base md:text-lg">
              {t('whatsHotDescription')}
            </div>
          </div>
          <ProductsCarousel items={items} pageType={pageType} />
        </div>
        <ViewMoreButton />
      </div>
    </div>
  );
}
